import React from 'react'
import Container from '../../components/common/container/Container'
import GridContainer from '../../components/common/grid/GridContainer'
import GridItem from '../../components/common/grid/GridItem'
import AccordionExpand from '../../components/common/accordion/Accordion'
import { MAINTENANCE_LIST } from '../../utils/constants/GlobalFormConstants'
import { COOKIE_KEY, DECRYPT_KEY } from '../../utils/constants/GlobalConstants'
import CryptoJS from 'crypto-js';
import Cookies from "js-cookie";

const Maintenance = () => {
    const [username, setUsername] = React.useState('');
    const encryptF = Cookies.get(COOKIE_KEY);

    React.useEffect(() => {
        if (encryptF) {
            const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
            const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            decryptData && setUsername(`Hello ${decryptData.given_name}`);
        }
    }, [encryptF]);

    return (
        <Container breadCrumb={false} title={username}>
            <GridContainer spacing={2}>
                <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
                    <AccordionExpand data={MAINTENANCE_LIST} />
                </GridItem>

            </GridContainer>
        </Container>

    )
}

export default Maintenance
